import React, { memo } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import EventsList from 'components/common/EventsList';
import { GlobalStyles } from 'tss-react';
import EventsCalendarView from 'components/common/EventsCalendar/EventsCalendarView';
import { useEmbedPostHeight } from 'hooks';

export interface IEventsScreenProps {
  top?: React.ReactNode;
  events: any[];
  isEventsFetching: boolean;
  onToggleFavoriteEvent: (id: number) => void;
  isCalendarView?: boolean;
  filtersHeight?: number;
  isEmbedded?: boolean;
}

interface StyleProps {
  isEmbedded: boolean;
}

// `minHeight`/`paddingTop` account for the global header (`UserHeader`, 64px) — not rendered when
// embedded (JPA-8032, see `src/pages/community-calendar/[marketSlug]/index.tsx`), so the screen can
// use the full viewport height and needs less top padding. When `isEmbedded` is falsy this matches
// the pre-existing non-embedded output exactly.
const useStyles = makeStyles<StyleProps>()((theme, { isEmbedded }) => ({
  root: {
    paddingTop: theme.spacing(isEmbedded ? 2 : 4),
    minHeight: isEmbedded ? '100vh' : 'calc(100vh - 64px)',
    [theme.breakpoints.down('md')]: {
      overflowX: 'hidden',
      // Remove overflowY: 'hidden' to allow proper scrolling and positioning
    },
  },
}));

const EventsScreen: React.FC<React.PropsWithChildren<IEventsScreenProps>> = (props) => {
  const { top, events, isEventsFetching, onToggleFavoriteEvent, isCalendarView, filtersHeight, isEmbedded } = props;
  const EventsView = isCalendarView ? EventsCalendarView : EventsList;

  useEmbedPostHeight(isEmbedded ?? false);

  const { classes } = useStyles({ isEmbedded: Boolean(isEmbedded) });
  return (
    <>
      <GlobalStyles
        styles={{
          body: {
            backgroundColor: 'white',
            // Ensure body can scroll properly
            overflowX: 'hidden',
          },
        }}
      />
      <Container maxWidth="lg" className={classes.root}>
        <EventsView
          filtersHeight={filtersHeight}
          top={top}
          events={events}
          hasFilters
          isEventsFetching={isEventsFetching}
          onToggleFavoriteEvent={onToggleFavoriteEvent}
        />
      </Container>
    </>
  );
};

export default memo(EventsScreen);
